/* eslint-disable no-console */
import IconButton from 'components/IconButton';
import React from 'react';

import { FilterConfig } from '../FilterTypes';

interface ActiveFiltersBarProps {
  filtersConfig: FilterConfig;
  onFiltersReset: () => void;
}

const ActiveFiltersBar: React.FC<ActiveFiltersBarProps> = ({
  filtersConfig,
  onFiltersReset,
}) => {
  // Memoized computation of filters that have a selection different from their default values
  const activeFilters = React.useMemo(() => {
    return filtersConfig.getActiveFilters();
  }, [filtersConfig]);

  // Function to reset all filters to their default values
  const resetAllFilters = () => {
    filtersConfig.resetAllFilters();
    onFiltersReset();
  };

  return (
    <div className="d-flex flex-wrap">
      {activeFilters.map((filter) => filter.renderFilterBadge(onFiltersReset))}
      {activeFilters.length > 0 && (
        <>
          <IconButton
            id="resetFiltersButton"
            iconClass="fa fa-xmark"
            tooltip="Remove All Filters"
            onClick={resetAllFilters}
          />
        </>
      )}
    </div>
  );
};

export default ActiveFiltersBar;
